// List IDs queries - FOR BULK DELETE
// ##########################################
export const listAccountIds = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const listUserIds = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        reloadYardId
        cognitoId
      }
      nextToken
    }
  }
`;
export const listInboundShipmentIds = /* GraphQL */ `
  query ListInboundShipments(
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountId
        reloadYardId
      }
      nextToken
    }
  }
`;
export const listSetupDataIds = /* GraphQL */ `
  query ListSetupDatas(
    $filter: ModelSetupDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSetupDatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cognitoId
        groups
      }
      nextToken
    }
  }
`;
export const listTaskIds = /* GraphQL */ `
  query ListTasks(
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;
export const listInventoryIds = /* GraphQL */ `
  query ListInventories(
    $filter: ModelInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        accountId
        productId
        inboundShipmentId
        outboundShipmentId
        areaId
        zoneId
        reloadYardCommodityId
        aggregateInventoryId
      }
      nextToken
    }
  }
`;
export const listAuditIds = /* GraphQL */ `
  query ListAudits(
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAudits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listHistoryNoteIds = /* GraphQL */ `
  query ListHistoryNotes(
    $filter: ModelHistoryNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHistoryNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        parentType
      }
      nextToken
    }
  }
`;

export const listPhotoIds = /* GraphQL */ `
  query ListPhotos(
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        parentId
        parentType
      }
      nextToken
    }
  }
`;

export const listShipmentLineItemIds = /* GraphQL */ `
  query ListShipmentLineItems(
    $filter: ModelShipmentLineItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShipmentLineItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        accountId
        outboundShipmentId
        inventoryId
      }
      nextToken
    }
  }
`;
export const listOutboundShipmentIds = /* GraphQL */ `
  query ListOutboundShipments(
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        accountId
      }
      nextToken
    }
  }
`;
export const listInvoiceIds = /* GraphQL */ `
  query ListInvoices(
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const listInvoiceServiceIds = /* GraphQL */ `
  query ListInvoiceServices(
    $filter: ModelInvoiceServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoiceServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const listServiceIds = /* GraphQL */ `
  query ListServices(
    $filter: ModelServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        accountId
      }
      nextToken
    }
  }
`;
export const listReloadYardIds = /* GraphQL */ `
  query ListReloadYards(
    $filter: ModelReloadYardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReloadYards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        groups
      }
      nextToken
    }
  }
`;
export const listReloadYardCapabilityIds = /* GraphQL */ `
  query ListReloadYardCapabilitys(
    $filter: ModelReloadYardCapabilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReloadYardCapabilitys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        capabilityId
      }
      nextToken
    }
  }
`;
export const listCapabilityIds = /* GraphQL */ `
  query ListCapabilitys(
    $filter: ModelCapabilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCapabilitys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const listReloadYardCommodityIds = /* GraphQL */ `
  query ListReloadYardCommoditys(
    $filter: ModelReloadYardCommodityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReloadYardCommoditys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        commodityId
      }
      nextToken
    }
  }
`;
export const listCommodityIds = /* GraphQL */ `
  query ListCommoditys(
    $filter: ModelCommodityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommoditys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const listAreaIds = /* GraphQL */ `
  query ListAreas(
    $filter: ModelAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;
export const listZoneIds = /* GraphQL */ `
  query ListZones(
    $filter: ModelZoneFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listZones(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        accountId
        areaId
      }
      nextToken
    }
  }
`;
export const listAisleIds = /* GraphQL */ `
  query ListAisles(
    $filter: ModelAisleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAisles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        areaId
        zoneId
      }
      nextToken
    }
  }
`;
export const listLocationIds = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        # accountId // we do not have this field in the schema
        areaId
        zoneId
        aisleId
        active
        sortKey
        productId
        productName
      }
      nextToken
    }
  }
`;
export const listLogIds = /* GraphQL */ `
  query ListLogs(
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
      }
      nextToken
    }
  }
`;

export const listProductIds = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountId
        reloadYardId
        productCode
        reloadYardCommodityId
      }
      nextToken
    }
  }
`;

export const listProductStatsIds = /* GraphQL */ `
  query ListProductStatss(
    $filter: ModelProductStatsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductStatss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productId
        accountId
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listRawDataIds = /* GraphQL */ `
  query ListRawDatas(
    $filter: ModelRawDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRawDatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        accountId
        braSessionId
      }
      nextToken
    }
  }
`;

// Additional missing list ID queries for entities with reloadYardId
export const listInventoryItemIds = /* GraphQL */ `
  query ListInventoryItems(
    $filter: ModelInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInventoryItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        inventoryId
        locationId
        areaId
        zoneId
        aisleId
      }
      nextToken
    }
  }
`;

export const listShipmentLineItemInventoryItemIds = /* GraphQL */ `
  query ListShipmentLineItemInventoryItems(
    $filter: ModelShipmentLineItemInventoryItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShipmentLineItemInventoryItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        shipmentLineItemId
        inventoryItemId
      }
      nextToken
    }
  }
`;

export const listSavedAddressIds = /* GraphQL */ `
  query ListSavedAddresss(
    $filter: ModelSavedAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSavedAddresss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        accountId
      }
      nextToken
    }
  }
`;

export const listSealIds = /* GraphQL */ `
  query ListSeals(
    $filter: ModelSealFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSeals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        referenceId
      }
      nextToken
    }
  }
`;

export const listFileIds = /* GraphQL */ `
  query ListFiles(
    $filter: ModelFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listAssetTypeIds = /* GraphQL */ `
  query ListAssetTypes(
    $filter: ModelAssetTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        areaId
      }
      nextToken
    }
  }
`;

export const listEventTypeIds = /* GraphQL */ `
  query ListEventTypes(
    $filter: ModelEventTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        areaId
        assetTypeId
      }
      nextToken
    }
  }
`;

export const listChecklistIds = /* GraphQL */ `
  query ListChecklists(
    $filter: ModelChecklistFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChecklists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        resourceId
        reloadYardCommodityId
      }
      nextToken
    }
  }
`;

export const listApiKeyIds = /* GraphQL */ `
  query ListApiKeys(
    $filter: ModelApiKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApiKeys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listTimeslotIds = /* GraphQL */ `
  query ListTimeslots(
    $filter: ModelTimeslotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeslots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        eventTypeId
        inboundId
        outboundId
      }
      nextToken
    }
  }
`;

export const listPaymentTermIds = /* GraphQL */ `
  query ListPaymentTerms(
    $filter: ModelPaymentTermFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentTerms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listCarrierUserIds = /* GraphQL */ `
  query ListCarrierUsers(
    $filter: ModelCarrierUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
      }
      nextToken
    }
  }
`;

export const listCarrierUserReloadYardCarrierIds = /* GraphQL */ `
  query ListCarrierUserReloadYardCarriers(
    $filter: ModelCarrierUserReloadYardCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierUserReloadYardCarriers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        carrierUserId
        carrierId
        reloadYardId
        # Dispatch or driver. The reset needs the distinction to know whose
        # biometrics have to be erased through the driverAdmin lambda; run it
        # through normalizeCarrierUserType, legacy rows carry the short forms.
        type
      }
      nextToken
    }
  }
`;

export const listAnnouncementIds = /* GraphQL */ `
  query ListAnnouncements(
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnnouncements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tenantId
      }
      nextToken
    }
  }
`;

export const listChargeRuleIds = /* GraphQL */ `
  query ListChargeRules(
    $filter: ModelChargeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChargeRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listCustomerReloadYardAccountIds = /* GraphQL */ `
  query ListCustomerReloadYardAccounts(
    $filter: ModelCustomerReloadYardAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerReloadYardAccounts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        customerId
        accountId
      }
      nextToken
    }
  }
`;

export const listTrackCarIds = /* GraphQL */ `
  query ListTrackCars(
    $filter: ModelTrackCarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTrackCars(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        trackId
        shipmentId
        parentType
        accountId
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listBarcodeIds = /* GraphQL */ `
  query ListBarcodes(
    $filter: ModelBarcodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBarcodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        inventoryId
        inventoryItemId
      }
      nextToken
    }
  }
`;

export const listTagIds = /* GraphQL */ `
  query ListTags(
    $filter: ModelTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listLocationTagIds = /* GraphQL */ `
  query ListLocationTags(
    $filter: ModelLocationTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        locationId
        tagId
      }
      nextToken
    }
  }
`;

export const listCarrierIds = /* GraphQL */ `
  query ListCarriers(
    $filter: ModelCarrierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarriers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        # The company this entry belongs to. Read-only for everyone but admin,
        # which is who runs the resets — it is how they tell a CarrierCompany
        # that still has entries from one no yard can reach.
        companyId
      }
      nextToken
    }
  }
`;

// Carrier/driver references only — used by the carrierApp reset to find the
// shipments that still point at a carrier or driver about to be deleted.
export const listInboundShipmentCarrierRefs = /* GraphQL */ `
  query ListInboundShipments(
    $filter: ModelInboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        carrierId
        carrierName
        driverId
        driverName
      }
      nextToken
    }
  }
`;

export const listOutboundShipmentCarrierRefs = /* GraphQL */ `
  query ListOutboundShipments(
    $filter: ModelOutboundShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOutboundShipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        carrier
        carrierId
        carrierName
        driverId
        driverName
      }
      nextToken
    }
  }
`;

export const listTimeslotCarrierRefs = /* GraphQL */ `
  query ListTimeslots(
    $filter: ModelTimeslotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeslots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        carrierId
        carrierUserId
      }
      nextToken
    }
  }
`;

// Minimal variant of the generated reloadYardCarrierByUser: answers "does this
// carrier user still belong to any yard?" without dragging the user, carrier
// and reloadYard connections along with every row.
export const reloadYardCarrierIdsByUser = /* GraphQL */ `
  query ReloadYardCarrierByUser(
    $carrierUserId: ID
    $limit: Int
    $nextToken: String
  ) {
    reloadYardCarrierByUser(
      carrierUserId: $carrierUserId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listWorkChargeRuleIds = /* GraphQL */ `
  query ListWorkChargeRules(
    $filter: ModelWorkChargeRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkChargeRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        parentId
        parentType
      }
      nextToken
    }
  }
`;

export const listZapierHookIds = /* GraphQL */ `
  query ListZapierHooks(
    $filter: ModelZapierHookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listZapierHooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listZapierActionIds = /* GraphQL */ `
  query ListZapierActions(
    $filter: ModelZapierActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listZapierActions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listWorkOrderIds = /* GraphQL */ `
  query ListWorkOrders(
    $filter: ModelWorkOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listWorkOrderItemIds = /* GraphQL */ `
  query ListWorkOrderItems(
    $filter: ModelWorkOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkOrderItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listSupportRequestIds = /* GraphQL */ `
  query ListSupportRequests(
    $filter: ModelSupportRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSupportRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

// Gate check-in surface. Both carry reloadYardId, so the default reset filter
// reaches them per yard — the driverAdmin devResetGate endpoint is the only
// other thing that clears them, and it is environment-wide.
export const listGateCheckInIds = /* GraphQL */ `
  query ListGateCheckIns(
    $filter: ModelGateCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGateCheckIns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        inboundId
        outboundId
      }
      nextToken
    }
  }
`;

export const listDriverSessionIds = /* GraphQL */ `
  query ListDriverSessions(
    $filter: ModelDriverSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDriverSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reloadYardId
        carrierUserId
        gateCheckInId
      }
      nextToken
    }
  }
`;

// The company layer above the yards. Neither model carries a reloadYardId — a
// company belongs to every yard that entered it — so these are only ever listed
// unfiltered, and the reset works out what is reachable by comparing them
// against the Carrier entries it can see.
export const listCarrierCompanyIds = /* GraphQL */ `
  query ListCarrierCompanys(
    $filter: ModelCarrierCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        businessName
      }
      nextToken
    }
  }
`;

export const listCarrierIdentifierClaimIds = /* GraphQL */ `
  query ListCarrierIdentifierClaims(
    $filter: ModelCarrierIdentifierClaimFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCarrierIdentifierClaims(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        scheme
        value
      }
      nextToken
    }
  }
`;

export const listRailEquipmentTypeIds = /* GraphQL */ `
  query ListRailEquipmentTypes(
    $filter: ModelRailEquipmentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRailEquipmentTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

export const listTruckEquipmentTypeIds = /* GraphQL */ `
  query ListTruckEquipmentTypes(
    $filter: ModelTruckEquipmentTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTruckEquipmentTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;

// A customer's account memberships in every yard, through the
// reloadYardAccountByCustomer GSI. The yard delete reads it to tell a customer
// who still works another yard from one the delete leaves with none.
export const reloadYardAccountIdsByCustomer = /* GraphQL */ `
  query ReloadYardAccountByCustomer(
    $customerId: ID
    $limit: Int
    $nextToken: String
  ) {
    reloadYardAccountByCustomer(
      customerId: $customerId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
      }
      nextToken
    }
  }
`;
